<template>
  <div class="d-flex flex-column ma-1" style="gap: 8px">
    <div
      v-for="option in question.choices"
      :key="option.value"
      class="semiglutide__option-container d-flex"
      :class="{ selected: option.value === selectedItem }"
      @click="onClick(option.value)"
    >
      <div class="flex-grow-1">
        <h2 :class="{ 'mt-1': option.value === 'existing medication' }">
          {{ getChoiceTitle(option) || option.value }}
        </h2>
        <h3 style="color: #64748b; font-weight: 600" v-if="option.value !== 'existing medication'">
          {{ option.value }}
        </h3>
        <p style="color: #64748b" class="mt-1" v-if="option.value !== 'existing medication'">
          The pharmacy will choose the formulation that results in the lowest cost for you.
        </p>
      </div>
      <div>
        <v-btn
          :large="$vuetify.breakpoint.mdAndUp"
          icon
          :color="option.value === selectedItem ? 'success' : ''"
        >
          <v-icon :large="$vuetify.breakpoint.mdAndUp">{{
            option.value === selectedItem ? 'mdi-check-circle' : 'mdi-checkbox-blank-circle-outline'
          }}</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.semiglutide__option-container {
  padding: 16px;
  background-color: white;
  border-radius: 16px;
  border: 2px solid #cbd5e1;

  cursor: pointer;

  &.selected {
    border: 2px solid transparent;
    outline: 4px solid var(--v-primary-base);

    h2 {
      color: var(--v-primary-darken1);
    }
  }
}
@media all and (max-width: 768px) {
  ::v-deep .semiglutide__option-container {
    h2 {
      font-size: 1rem;
    }
    h3 {
      font-size: 0.8rem;
    }

    p {
      font-size: 0.7rem;
    }
  }
}
</style>
<script>
export default {
  props: {
    question: Object,
  },

  computed: {
    selectedItem() {
      return this.question.selectedItem?.id;
    },
  },
  methods: {
    getChoiceTitle(option) {
      console.log('get option: ', option.value);
      const medName =
        {
          Semaglutide: 'Ozempic or Wegovy',
          Tirzepatide: 'Mounjaro or Zepbound',
          Liraglutide: 'Victoza',
          'existing medication':
            'I am already on one of these medications and wish to continue on it',
        }[option.value.trim()] || null;
      return medName;
    },
    onClick(value) {
      if (this.question.value === value) {
        this.question.value = null;
        return;
      }
      this.question.value = value;
    },
  },
};
</script>
